import { h } from 'preact'
//import Moment from 'moment'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Project = (props) => {

  let project = props.project
  let title  = project.title.rendered
  //let branches = project.branch_names.join(', ')
  let link = project.link
  let client = project.client
  let feat_image = project.feat_image
  let branch = project.branch_names[0]
  let text_show = 'Bekijk'
  let size = project.size_meta

  // if (props.language == 'en') {
  //   text_show = 'View'
  //   date = Moment(raw_date).format('MM/DD/YYYY')
  // }
  return (
    <div className={`c-case c-cases__col` }>
      <a href={link} className="c-case__link">

        <div className="c-case__image" 
        dangerouslySetInnerHTML={{ __html: feat_image }} 
        />
 

        <div className="c-case__header">
          <div className="c-case__title" dangerouslySetInnerHTML={{ __html: title }} />
          <div className="c-case__branch" dangerouslySetInnerHTML={{ __html: branch }} />
          <svg class="c-icon c-case__icon">
            <use href="#arrow-right" xlinkHref="#arrow-right"></use>
          </svg>
        </div>

      </a>
    </div>
  )
}

export default Project
 


// WEBPACK FOOTER //
// ./src/js/app/components/Project.js